import { ofType } from "redux-observable"
import { concat, from, of, zip } from "rxjs"
import {
    catchError,
    concatMap,
    endWith,
    flatMap,
    map,
    mergeAll,
    mergeMap,
    startWith,
    switchMap,
    take
} from "rxjs/operators"

import CONSTANTS from "../../assets/js/Constants"

// Với từng function, nhận 2 stream là action$ và state$ => dùng pipe() để nối các operator lại. Lấy type của action gửi lên server => gửi api => nhận data => trả về action set của reducer
const getFuelTypeList = (action$, state$) =>
    action$.pipe(
        ofType(CONSTANTS.ACTION.FUEL_CHANGE.GET_FUEL_TYPE_LIST),
        mergeMap((action) => {
            const api = async () => {
                const fuelTypeList = await CONSTANTS.FUNCTION.AXIOS.GET(
                    CONSTANTS.URL.FUEL_CHANGE.GET_FUEL_TYPE_LIST
                )
                let arrayAction = []
                arrayAction.push(
                    CONSTANTS.FUNCTION.REDUX.DISPATCH(
                        CONSTANTS.ACTION.FUEL_CHANGE.SET_FUEL_TYPE_LIST,
                        {
                            data: fuelTypeList.data.data,
                            total_row: fuelTypeList.data.total_row,
                            rows_perpage: fuelTypeList.data.rows_perpage
                        }
                    )
                )
                return arrayAction
            }
            return concat(
                from(api()).pipe(
                    mergeMap((res) => {
                        return concat(from(res))
                    }),
                    catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
                )
            )
        })
    )

const getLocationList = (action$, state$) =>
    action$.pipe(
        ofType(CONSTANTS.ACTION.FUEL_CHANGE.GET_LOCATION_LIST),
        mergeMap((action) => {
            const api = async () => {
                const location_list = await CONSTANTS.FUNCTION.AXIOS.GET(
                    CONSTANTS.URL.FUEL_CHANGE.GET_LOCATION_LIST
                )
                let arrayFunction = []
                arrayFunction.push(
                    CONSTANTS.FUNCTION.REDUX.DISPATCH(
                        CONSTANTS.ACTION.FUEL_CHANGE.SET_LOCATION_LIST,
                        {
                            data: location_list.data.data,
                            total_row: location_list.data.total_row
                        }
                    )
                )
                return arrayFunction
            }
            return concat(
                from(api()).pipe(
                    mergeMap((res) => {
                        return concat(from(res))
                    }),
                    catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
                )
            )
        })
    )

const getVehiclesList = (action$, state$) =>
    action$.pipe(
        ofType(CONSTANTS.ACTION.FUEL_CHANGE.GET_VEHICLES_LIST),
        mergeMap((action) => {
            const api = async () => {
                const vehiclesList = await CONSTANTS.FUNCTION.AXIOS.GET(
                    CONSTANTS.URL.FUEL_CHANGE.GET_VEHICLES_LIST
                )
                let arrayFunction = []
                arrayFunction.push(
                    CONSTANTS.FUNCTION.REDUX.DISPATCH(
                        CONSTANTS.ACTION.FUEL_CHANGE.SET_VEHICLES_LIST,
                        {
                            data: vehiclesList.data.data
                            // total_row: vehiclesList.data.total_row,
                            // rows_perpage: vehiclesList.data.rows_perpage
                        }
                    )
                )
                return arrayFunction
            }
            return concat(
                from(api()).pipe(
                    mergeMap((res) => {
                        return concat(from(res))
                    }),
                    catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
                )
            )
        })
    )

const getDriverList = (action$, state$) =>
    action$.pipe(
        ofType(CONSTANTS.ACTION.FUEL_CHANGE.GET_DRIVER_LIST),
        mergeMap((action) => {
            const api = async () => {
                const driverList = await CONSTANTS.FUNCTION.AXIOS.GET(
                    CONSTANTS.URL.FUEL_CHANGE.GET_DRIVER_LIST
                )
                let arrayFunction = []
                arrayFunction.push(
                    CONSTANTS.FUNCTION.REDUX.DISPATCH(
                        CONSTANTS.ACTION.FUEL_CHANGE.SET_DRIVER_LIST,
                        {
                            data: driverList.data.data
                            // total_row: driverList.data.total_row,
                            // rows_perpage: driverList.data.rows_perpage
                        }
                    )
                )
                return arrayFunction
            }
            return concat(
                from(api()).pipe(
                    mergeMap((res) => {
                        return concat(from(res))
                    }),
                    catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
                )
            )
        })
    )

const getViewDetailAction = (action$, state$) =>
    action$.pipe(
        ofType(CONSTANTS.ACTION.FUEL_CHANGE.GET_VIEW_DETAIL_ACTION),
        mergeMap((action) => {
            const api = async () => {
                const viewDetail = await CONSTANTS.FUNCTION.AXIOS.GET(
                    `${CONSTANTS.URL.FUEL_CHANGE.GET_VIEW_DETAIL_ACTION}?id=${action.payload.id}&trk_time=${action.payload.trk_time}`
                )
                let arrayFunction = []
                arrayFunction.push(
                    CONSTANTS.FUNCTION.REDUX.DISPATCH(
                        CONSTANTS.ACTION.FUEL_CHANGE.SET_VIEW_DETAIL_ACTION,
                        {
                            data: viewDetail.data.data
                        }
                    )
                )
                return arrayFunction
            }

            return concat(
                from(api()).pipe(
                    mergeMap((res) => {
                        return concat(from(res))
                    }),
                    catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
                )
            )
        })
    )

const postSearchAction = (action$, state$) =>
    action$.pipe(
        ofType(CONSTANTS.ACTION.FUEL_CHANGE.POST_SEARCH_ACTION),
        mergeMap((action) => {
            const api = async () => {
                const newPayload = {
                    ...action.payload,
                    from_date:
                        CONSTANTS.FUNCTION.COMMON.convertDateToStringCommonFormat(
                            action.payload.from_date
                        ),
                    to_date:
                        CONSTANTS.FUNCTION.COMMON.convertDateToStringCommonFormat(
                            action.payload.to_date
                        )
                }
                const fuelChangesList = await CONSTANTS.FUNCTION.AXIOS.POST(
                    CONSTANTS.URL.FUEL_CHANGE.POST_SEARCH_ACTION,
                    newPayload
                )
                let arrayFunction = []
                arrayFunction.push(
                    CONSTANTS.FUNCTION.REDUX.DISPATCH(
                        CONSTANTS.ACTION.FUEL_CHANGE.UPDATE_FUEL_CHANGES_LIST,
                        {
                            data: fuelChangesList.data.data,
                            total_row: fuelChangesList.data.total_row,
                            rows_perpage: fuelChangesList.data.rows_perpage
                        }
                    )
                )
                return arrayFunction
            }

            return concat(
                from(api()).pipe(
                    mergeMap((res) => {
                        return concat(from(res))
                    }),
                    catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
                )
            )
        })
    )

// API tạo mới 1 lần đổ nhiên liệu
const postInsertFuelChange = (action$, state$) =>
    action$.pipe(
        ofType(CONSTANTS.ACTION.FUEL_CHANGE.POST_INSERT_FUEL_CHANGE),
        mergeMap((action) => {
            const api = async () => {
                const newPayload = {
                    ...action.payload,
                    trk_time:
                        CONSTANTS.FUNCTION.COMMON.convertDateToStringCommonFormat(
                            action.payload.trk_time,
                            "dd/MM/yyyy hh:mm:00"
                        )
                }
                const insertMessage = await CONSTANTS.FUNCTION.AXIOS.POST(
                    CONSTANTS.URL.FUEL_CHANGE.POST_INSERT_FUEL_CHANGE,
                    newPayload
                )
                let arrayFunction = []
                insertMessage.data.status
                    ? arrayFunction.push(
                          CONSTANTS.FUNCTION.REDUX.DISPATCH(
                              CONSTANTS.ACTION.SYSTEM.STATUS,
                              insertMessage.data.status
                          )
                      )
                    : arrayFunction.push(
                          CONSTANTS.FUNCTION.REDUX.DISPATCH(
                              CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE,
                              insertMessage.data.mess
                          )
                      )
                arrayFunction.push(
                    CONSTANTS.FUNCTION.REDUX.DISPATCH(
                        CONSTANTS.ACTION.FUEL_CHANGE
                            .SET_INSERT_FUEL_CHANGE_MESSAGE,
                        {
                            status: insertMessage.data.status,
                            mess: insertMessage.data.mess
                        }
                    )
                )
                return arrayFunction
            }

            return concat(
                from(api()).pipe(
                    mergeMap((res) => {
                        return concat(from(res))
                    }),
                    catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
                )
            )
        })
    )

// API cập nhật 1 lần đổ nhiên liệu
const postUpdateFuelChange = (action$, state$) =>
    action$.pipe(
        ofType(CONSTANTS.ACTION.FUEL_CHANGE.POST_UPDATE_FUEL_CHANGE),
        mergeMap((action) => {
            const api = async () => {
                const newPayload = {
                    ...action.payload,
                    trk_time:
                        CONSTANTS.FUNCTION.COMMON.convertDateToStringCommonFormat(
                            action.payload.trk_time,
                            "dd/MM/yyyy hh:mm:00"
                        )
                }
                const updateMessage = await CONSTANTS.FUNCTION.AXIOS.POST(
                    CONSTANTS.URL.FUEL_CHANGE.POST_UPDATE_FUEL_CHANGE,
                    newPayload
                )
                let arrayFunction = []
                updateMessage.data.status
                    ? arrayFunction.push(
                          CONSTANTS.FUNCTION.REDUX.DISPATCH(
                              CONSTANTS.ACTION.SYSTEM.STATUS,
                              updateMessage.data.status
                          )
                      )
                    : arrayFunction.push(
                          CONSTANTS.FUNCTION.REDUX.DISPATCH(
                              CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE,
                              updateMessage.data.mess
                          )
                      )
                arrayFunction.push(
                    CONSTANTS.FUNCTION.REDUX.DISPATCH(
                        CONSTANTS.ACTION.FUEL_CHANGE
                            .SET_UPDATE_FUEL_CHANGE_MESSAGE,
                        {
                            status: updateMessage.data.status,
                            mess: updateMessage.data.mess
                        }
                    )
                )
                return arrayFunction
            }

            return concat(
                from(api()).pipe(
                    mergeMap((res) => {
                        return concat(from(res))
                    }),
                    catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
                )
            )
        })
    )

// API xoá 1 lần đổ nhiên liệu
const getDeleteFuelChange = (action$, state$) =>
    action$.pipe(
        ofType(CONSTANTS.ACTION.FUEL_CHANGE.GET_DELETE_FUEL_CHANGE),
        mergeMap((action) => {
            const api = async () => {
                let newPayload = {
                    ...action.payload
                }
                if (newPayload.title) delete newPayload[`title`]
                const deleteMessage = await CONSTANTS.FUNCTION.AXIOS.GET(
                    CONSTANTS.URL.FUEL_CHANGE.GET_DELETE_FUEL_CHANGE,
                    action.payload
                )
                let arrayFunction = []
                deleteMessage.data.status
                    ? arrayFunction.push(
                          CONSTANTS.FUNCTION.REDUX.DISPATCH(
                              CONSTANTS.ACTION.SYSTEM.STATUS,
                              deleteMessage.data.status
                          )
                      )
                    : arrayFunction.push(
                          CONSTANTS.FUNCTION.REDUX.DISPATCH(
                              CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE,
                              deleteMessage.data.mess
                          )
                      )
                arrayFunction.push(
                    CONSTANTS.FUNCTION.REDUX.DISPATCH(
                        CONSTANTS.ACTION.FUEL_CHANGE
                            .SET_DELETE_FUEL_CHANGE_MESSAGE,
                        {
                            status: deleteMessage.data.status,
                            mess: deleteMessage.data.mess
                        }
                    )
                )
                return arrayFunction
            }

            return concat(
                from(api()).pipe(
                    mergeMap((res) => {
                        return concat(from(res))
                    }),
                    catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
                )
            )
        })
    )

export default {
    getFuelTypeList,
    getLocationList,
    getVehiclesList,
    getDriverList,
    getViewDetailAction,
    postSearchAction,
    postInsertFuelChange,
    postUpdateFuelChange,
    getDeleteFuelChange
}
